module.exports = __webpack_public_path__ + "static/media/umbrella.5a008a8a.svg";